import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import {
  FireFilled,
  SnippetsFilled,
  HddFilled,
  SettingFilled,
  RedditCircleFilled,
  BoxPlotFilled,
  UserOutlined,
  GoldFilled,
  FallOutlined,
  RiseOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  BarChartOutlined,
  PieChartOutlined,
  SyncOutlined,
  BuildOutlined,
  DeploymentUnitOutlined,
  AppstoreAddOutlined,
  GoldOutlined,
  TeamOutlined,
  MenuOutlined,
  ApiOutlined,
  CopyOutlined,
  MoreOutlined,
  RedoOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseOutlined,
  AreaChartOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  ProfileOutlined,
  SnippetsOutlined,
  FileOutlined,
} from '@ant-design/icons-vue';
import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'VAIcon',
  props: {
  type: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const components = {
  'fire-filled': FireFilled,
  'snippets-filled': SnippetsFilled,
  'hdd-filled': HddFilled,
  'setting-filled': SettingFilled,
  'reddit-circle-filled': RedditCircleFilled,
  'box-plot-filled': BoxPlotFilled,
  'user-outlined': UserOutlined,
  'gold-filled': GoldFilled,
  'fall-outlined': FallOutlined,
  'rise-outlined': RiseOutlined,
  'fullscreen-exit-outlined': FullscreenExitOutlined,
  'fullscreen-outlined': FullscreenOutlined,
  'barChart-outlined': BarChartOutlined,
  'pie-chart-outlined': PieChartOutlined,
  'sync-outlined': SyncOutlined,
  'build-outlined': BuildOutlined,
  'deployment-unit-outlined': DeploymentUnitOutlined,
  'appstore-add-outlined': AppstoreAddOutlined,
  'gold-outlined': GoldOutlined,
  'team-outlined': TeamOutlined,
  'menu-outlined': MenuOutlined,
  'api-outlined': ApiOutlined,
  'copy-outlined': CopyOutlined,
  'more-outlined': MoreOutlined,
  'redo-outlined': RedoOutlined,
  'edit-outlined': EditOutlined,
  'delete-outlined': DeleteOutlined,
  'close-outlined': CloseOutlined,
  'area-chart-outlined': AreaChartOutlined,
  'caret-up-outlined': CaretUpOutlined,
  'caret-down-outlined': CaretDownOutlined,
  'profile-outlined': ProfileOutlined,
  'snippets-outlined': SnippetsOutlined,
  'file-outlined': FileOutlined,
} as any;

const component = computed(() => {
  return components[props.type];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(component.value)))
  ]))
}
}

})